import { Italiana } from "next/font/google";
import React from "react";
import Modal from "react-bootstrap/Modal";

import Button from "@/components/core/button";
import TextInput from "@/components/core/text-input";
import useCollection from "@/hooks/useCollection";

const italiana = Italiana({
  subsets: ["latin"],
  weight: "400",
});

interface AddCollectionModalProps extends React.HTMLAttributes<HTMLDivElement> {
  onSuccess?: (collection: any) => void;
}

const AddCollectionModal: React.FC<AddCollectionModalProps> = ({
  onSuccess,
  children,
}) => {
  const [name, setName] = React.useState("");
  const [show, setShow] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [nameError, setNameError] = React.useState("");
  const { createCollection } = useCollection();

  const handleCreateCollection = async () => {
    if (nameError) {
      return;
    }
    setIsLoading(true);
    await createCollection({
      name,
      onSuccess: (collection) => {
        if (onSuccess) {
          onSuccess(collection);
        }
        setShow(false);
        setName("");
      },
    });
    setIsLoading(false);
  };

  const handleCloseModal = async () => {
    setShow(false);
  };

  const onNameChange = (e: any) => {
    setName(e.target.value);
  };

  React.useEffect(() => {
    if (name.length > 50) {
      setNameError("The collection name must not be more than 50 characters.");
    } else {
      setNameError("");
    }
  }, [name]);

  return (
    <>
      {React.isValidElement(children) &&
        React.cloneElement(children, {
          // @ts-expect-error ignore
          onClick: () => {
            if (children.props.onClick) {
              children.props.onClick();
            }
            setShow(true);
          },
        })}
      <Modal
        show={show}
        centered
        onHide={() => setShow(false)}
        style={{ zIndex: 999999 }}
      >
        <div className="modal-content">
          <div className={`${italiana.className} modal-title`}>
            Create new collection
          </div>
          <div className="modal-section">
            <p className="section-title">Name</p>
            <TextInput
              onChange={onNameChange}
              placeholder="like “Italy trip” or “summer in the city”"
              errorMessage={nameError}
              autoFocus
            />
          </div>
          <div className="modal-actions">
            <Button
              style={{
                border: "1px solid #E7E7E7",
                backgroundColor: "#fff",
                color: "#191919",
              }}
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button onClick={handleCreateCollection} isLoading={isLoading}>
              Create
            </Button>
          </div>
        </div>
      </Modal>
      <style jsx>{`
        .modal-content {
          padding: 40px;

          .modal-title {
            color: #191919;
            font-size: 36px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            text-align: center;
          }
          .modal-section {
            margin-top: 40px;

            .section-title {
              color: #191919;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: 100%; /* 14px */
              margin-bottom: 16px;
            }
          }

          .modal-actions {
            margin-top: 32px;
            display: grid;
            grid-template-columns: 1fr 1fr;
            column-gap: 16px;
          }
        }
        @media (max-width: 768px) {
        }
      `}</style>
    </>
  );
};

export default AddCollectionModal;
